import { Loader2 } from "lucide-react";
import { cn } from "../../lib/cn";

// Literal size classes — Tailwind can't see interpolated strings.
const SPINNER_SIZE = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
} as const;

interface SpinnerProps {
  size?: keyof typeof SPINNER_SIZE;
  className?: string;
}

export function Spinner({ size = "md", className }: SpinnerProps) {
  return (
    <Loader2
      aria-hidden="true"
      className={cn("animate-spin text-sky-600", SPINNER_SIZE[size], className)}
    />
  );
}

/** Loading state inside a section, tab panel or dialog (PageLoader fills the whole screen). */
export function InlineLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div role="status" className="flex items-center justify-center gap-2.5 py-10 text-sm text-neutral-600">
      <Spinner size="sm" />
      {label}
    </div>
  );
}

/**
 * Full-screen centered loading state. The visible text label is what survives
 * prefers-reduced-motion (the global CSS freezes animate-spin).
 */
export function PageLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div role="status" className="flex min-h-screen flex-col items-center justify-center gap-3">
      <Spinner size="lg" />
      <p className="text-sm font-medium text-neutral-600">{label}</p>
    </div>
  );
}
